import { createReducer } from '@reduxjs/toolkit';
import { checkOutRequest } from '../actions/checkOutAction';

const initialState = {

};
export default createReducer(initialState, (builder) => {
  builder.addCase(checkOutRequest.fulfilled, (state, action) => {
    console.log(action);
  });
});
